import { Star } from "lucide-react";

export function SkillTag({ name, stars = 0 }) {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-slate-100 border border-slate-200" data-testid="skill-tag">
      <span className="text-sm font-medium text-slate-700">{name}</span>
      <span className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} size={13} className={i <= stars ? "fill-amber-400 text-amber-400" : "fill-slate-300 text-slate-300"} />
        ))}
      </span>
    </div>
  );
}
